import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import { MobileNav } from '../components/MobileNav';
export function DecodeInput() {
  const navigate = useNavigate();
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [text, setText] = useState('');
  // Auto-focus on load
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  }, []);
  const handleSubmit = () => {
    // Store the input for the reveal page (even if empty)
    sessionStorage.setItem('decodeInput', text);
    sessionStorage.setItem('decodePath', 'situation');
    navigate('/decode/reveal');
  };
  return <>
      <Helmet data-id="element-946">
        <title data-id="element-947">Self Decode | Lazy Monk Labs</title>
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-948">
        <MobileNav data-id="element-949" />

        <main className="pt-20 sm:pt-24 pb-16 sm:pb-20" data-id="element-950">
          <div className="max-w-2xl mx-auto px-6 sm:px-8" data-id="element-951">
            {/* Page Title */}
            <section className="py-12 sm:py-16" data-id="element-952">
              <h1 className="text-xl sm:text-2xl md:text-3xl leading-relaxed text-[#F5F5F5]" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-953">
                What feels slightly off right now?
              </h1>
            </section>

            {/* Supporting Copy - Permission Language */}
            <section className="pb-8 sm:pb-10" data-id="element-954">
              <p className="text-base text-gray-400 leading-relaxed" data-id="element-955">
                This doesn't need to be clear or complete. A few words are
                enough.
              </p>
            </section>

            {/* Input Field */}
            <section className="pb-6" data-id="element-956">
              <textarea ref={textareaRef} value={text} onChange={e => setText(e.target.value)} placeholder="For example: work feels scattered, I feel ahead of my body, something is unresolved, or nothing specific — just a sense." rows={6} className="w-full bg-[#0A0A0A] border border-[#2B2B2B] text-[#F5F5F5] text-base leading-relaxed p-5 sm:p-6 focus:outline-none focus:border-gray-500 transition-colors resize-none placeholder:text-gray-600" style={{
              minHeight: '180px'
            }} data-id="element-957" />
            </section>

            {/* Skip Microcopy */}
            <section className="pb-10 sm:pb-12" data-id="element-958">
              <p className="text-sm text-gray-500" data-id="element-959">
                You can also{' '}
                <Link to="/decode/details" className="text-gray-400 hover:text-[#F5F5F5] transition-colors border-b border-[#2B2B2B] hover:border-gray-500 pb-0.5" data-id="element-960">
                  skip this
                </Link>{' '}
                and go straight to your Personal Decode.
              </p>
            </section>

            {/* Primary CTA */}
            <section data-id="element-961">
              <button onClick={handleSubmit} className="w-full px-8 py-4 sm:py-5 bg-[#F5F5F5] text-[#0A0A0A] text-sm font-medium uppercase tracking-widest hover:bg-gray-200 transition-colors" data-id="element-962">
                Continue
              </button>
            </section>
          </div>
        </main>
      </div>
    </>;
}